/**
 * Street lines for a MailingAddressGrp, with the 2026 unit box folded in.
 *
 * Ported verbatim from core-api efile/A2A-iris/1042-S/streetLines.ts, which the core-api
 * 1098 generator shares. The engine's 1042-S generator predates that file, so the helper
 * lives beside its only engine caller.
 *
 * The 2026 forms give the party a unit box (apt. no., room or suite no.), but the TY2026
 * IRIS XSD still has only AddressLine1Txt and AddressLine2Txt, so the unit rides on a
 * street line: after the street with a single space, or on its own when there is no street.
 *
 * StreetAddressType caps a line at 35 characters, and the sanitizer cuts anything longer. A
 * unit appended to a long street would be the part cut off, so when street + unit does not
 * fit on line 1 and line 2 is free, the unit moves to line 2 instead of being lost.
 */
export const IRS_STREET_LINE_MAX = 35;

const clean = (v: unknown) => String(v ?? "").trim();

export function streetLinesWithUnit(
  street1: unknown,
  street2: unknown,
  unit: unknown
): { line1: string; line2: string } {
  const line1 = clean(street1);
  const line2 = clean(street2);
  const unitNo = clean(unit);

  if (!unitNo) return { line1, line2 };
  if (!line1) return { line1: unitNo, line2 };

  const joined = `${line1} ${unitNo}`;
  if (joined.length <= IRS_STREET_LINE_MAX || line2) {
    return { line1: joined, line2 };
  }
  return { line1, line2: unitNo };
}
